import { Language } from '../constants';
export const CurrencyFieldVariant = {
  NORMAL: 'normal',
  DENSE: 'dense'
};
export const CURRENCY_FIELD_TRANSLATION_KEYS = {
  currencySelectAccessibleLabel: 'component.CurrencyField.currencySelectAccessibleLabel'
};
export const CURRENCY_FIELD_TRANSLATIONS = {
  [Language.EN]: {
    [CURRENCY_FIELD_TRANSLATION_KEYS.currencySelectAccessibleLabel]: 'Currency'
  },
  [Language.PL]: {
    [CURRENCY_FIELD_TRANSLATION_KEYS.currencySelectAccessibleLabel]: 'Waluta'
  },
  [Language.CS]: {
    [CURRENCY_FIELD_TRANSLATION_KEYS.currencySelectAccessibleLabel]: 'Měna'
  },
  [Language.SK]: {
    [CURRENCY_FIELD_TRANSLATION_KEYS.currencySelectAccessibleLabel]: 'Mena'
  }
};